// extracted by mini-css-extract-plugin
export default {"icon":"Toast-module__icon__AnK2I","successIcon":"Toast-module__successIcon__Zp1GP","failureIcon":"Toast-module__failureIcon__MJ2rd","message":"Toast-module__message__YNnSY"};